/**
 * Should contain all active Posthog feature flags, mapping
 * human-readable enum key to the feature flag ID within posthog.
 */
export enum FeatureFlag {
  UseBlocksRestricted = "use-blocks-restricted",
  UseCreatorPersonas = "use-creator-personas",
  UseTransferOwnership = "use-transfer-ownership",
  UseWorkspace = "use-workspace",
  RemoveModelSelector = "remove-model-selector",
  UseZapierIntegration = "use-zapier-integration",
  UseExternalID = "use-external-id",
  UseStacksRestricted = "use-stacks-restricted",
  UseFavorites = "use-favorites",
  UseContacts = "use-contacts",
  UseDocAnalysisWidget = "use-doc-analysis-widget",
}
